import { useTheme } from 'hooks';
import { SunIcon, MoonIcon } from './icons';

/**
 * ThemeToggle — a navbar icon button that flips between light and dark.
 * Quick, discoverable companion to the fuller control in Settings (which also
 * offers "System"). Reflects the resolved theme so the icon always matches what
 * the user is looking at.
 */
export default function ThemeToggle() {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      className="flex h-10 w-10 items-center justify-center rounded-xl text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-900"
    >
      {isDark ? <MoonIcon aria-hidden /> : <SunIcon aria-hidden />}
    </button>
  );
}
